import { ReactNode } from 'react';
import { Layout } from '@/components/layout/Layout';
import { DashboardProvider } from '@/components/dashboard/core/DashboardContext';
import { DashboardDragDrop } from '@/components/dashboard/core/DashboardDragDrop';

interface DashboardWrapperProps {
  children: ReactNode;
}

export function DashboardWrapper({ children }: DashboardWrapperProps) {
  return (
    <DashboardProvider>
      <DashboardDragDrop>
        <Layout>
          {children}
        </Layout>
      </DashboardDragDrop>
    </DashboardProvider>
  );
}
